import { render, staticRenderFns } from "./ActBox.vue?vue&type=template&id=f2c6d12e&scoped=true"
import script from "./ActBox.vue?vue&type=script&lang=ts"
export * from "./ActBox.vue?vue&type=script&lang=ts"
import style0 from "./ActBox.vue?vue&type=style&index=0&id=f2c6d12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c6d12e",
  null
  
)

export default component.exports